import React from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, Team } from "..";

export const TeamJustine = () => {
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const aboutDetails = useStore((state) => state.aboutDetails);

  const overlay = {
    where: "aboutJustine",
    title: "Meet The Trainer",
    // caption: "We need a caption",
  };
  const info = {
    routes: {
      Home: "/",
      "Todo's Team": getLink(pathTitles.MEETTHETEAM),
      "Meet The Trainer": getLink(pathTitles.MEETTHETRAINER),
    },
    body: aboutDetails.JUSTINE.body,
  };
  return (
    <>
      <SEO
        title="Meet Justine — Professional Dog Trainer in Indianapolis"
        description="Meet Justine, founder and lead trainer at Todo's Translator. Years of professional experience helping dogs and their families in Indianapolis, Carmel, Noblesville and beyond."
        path="/meet-the-trainer/justine"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <Team info={info} />
        </>
      )}
    </>
  );
};
